export default __webpack_public_path__ + "static/media/LogoFalabella.204047ea.svg";